// Style for logout page
const Style = () => ({
  pageText: {
    marginTop: 20,
  },
});

export default Style;
